import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';

import { Environment, ProcedureTipo } from '../../models/-index';

@Injectable()
export class ProcedureTipoService extends CrudGenericsService<ProcedureTipo, number> {
  // private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ProcedureTipo`);
    //  this.base = `${env.apiUrl}/api/ProceduraTipo/`;
  }
}
